import DashboardPage from './pages/student/DashboardPage';
import ExplorePage from './pages/student/ExplorePage';
import MomentsPage from './pages/student/MomentsPage';
import MyCoursesPage from './pages/student/MyCoursesPage';
import PiggyBankPage from './pages/student/PiggyBankPage';
import NotificationPage from './pages/student/NotificationPage';
import TrainerDashbaordPage from './pages/trainer/TrainerDashbaordPage';
import TrainerSchedulesPage from './pages/trainer/TrainerSchedulesPage';
import TrainerStudentsListPage from './pages/trainer/TrainerStudentsListPage';
import TrainerStudentsCoursesPage from './pages/trainer/TrainerStudentsCoursesPage';
import TrainerPayoutPage from './pages/trainer/TrainerPayoutPage';
import ApartmentDashPage from './pages/apartment/ApartmentDashPage';
import CoOrdinatorDashPage from './pages/coordinator/CoOrdinatorDashPage';
import StudentListPage from './pages/admin/StudentListPage';
import TrainerListPage from './pages/admin/TrainerListPage';
import ApartmentListPage from './pages/admin/ApartmentListPage';
import CoOrdinatorListPage from './pages/admin/CoOrdinatorListPage';
import CityPage from './pages/admin/CityPage';
import StatePage from './pages/admin/StatePage';
import CountryPage from './pages/admin/CountryPage';
import AllUserListPage from './pages/admin/AllUserListPage';
import RoleListPage from './pages/admin/RoleListPage';
import SchoolListPage from './pages/admin/SchoolListPage';
import CourseListPage from './pages/admin/CourseListPage';
import EventListPage from './pages/admin/EventListPage';
import OrderListPage from './pages/admin/OrderListPage';
import FacilityListPage from './pages/admin/FacilityListPage';
import FacilityListApartmentPage from './pages/marketingExecutive/FacilityListApartmentPage';
import AddMarketingExecutivePage from './pages/marketingManager/AddMarketingExecutivePage';
import ConstactPersonListPage from './pages/marketingExecutive/ConstactPersonListPage';
import ZoneListPage from './pages/marketingManager/ZoneListPage';
import ApartmentListMarExe from './pages/marketingExecutive/ApartmentListMarExe';
import AddUserListPage from './pages/coordinator/AddUserListPage';
import NewTCManagerPage from './pages/marketingManager/NewTCManagerPage';
import OnboardTCManagerPage from './pages/marketingManager/OnboardTCManagerPage';
import NewTCExecutiveManager from './pages/marketingExecutive/NewTCExecutiveManager';
import NewTCCoordinatorPage from './pages/coordinator/NewTCCoordinatorPage';
import CoodiApartmentListPage from './pages/coordinator/CoodiApartmentListPage';
import AdminTCListPage from './pages/admin/AdminTCListPage';
import ApartmentTCListPage from './pages/apartment/ApartmentTCListPage';
import AdminStudentEnquiryPage from './pages/admin/AdminStudentEnquiryPage';
import ZoneManagerTCListPage from './pages/zoneManager/ZoneManagerTCListPage';
import ZoneManagerEnquiryListPage from './pages/zoneManager/ZoneManagerEnquiryListPage';
import ZoneManagerMomentAttendancePage from './pages/zoneManager/ZoneManagerMomentAttendancePage';
import CoordinatorMomentAttendancePage from './pages/coordinator/CoordinatorMomentAttendancePage';
import AdminMomentAttendancePage from './pages/admin/AdminMomentAttendancePage';
import AdminViewTrainerAtdPage from './pages/admin/AdminViewTrainerAtdPage';
import ZoneManagerViewTraAtdPage from './pages/zoneManager/ZoneManagerViewTraAtdPage';
import CoordinatorViewTraAtdPage from './pages/coordinator/CoordinatorViewTraAtdPage';
import TrainerAttendanceListPage from './pages/trainer/TrainerAttendanceListPage';
import AssignTranerPage from './pages/admin/AssignTranerPage';
import TrainerStudentEnquiryPage from './pages/trainer/TrainerStudentEnquiryPage';
import StudentCourseDetailPage from './pages/student/StudentCourseDetailPage';
import CluserHeadListPage from './pages/admin/CluserHeadListPage';
import AdminZoneListPage from './pages/admin/AdminZoneListPage';
import AparmentDetailPage from './pages/admin/AparmentDetailPage';
import ZoneHeadEnquiryFormPage from './pages/zoneHead/ZoneHeadEnquiryFormPage';
import ZoneHeadStudentListPage from './pages/zoneHead/ZoneHeadStudentListPage';
import ZoneHeadMomentAtdPage from './pages/zoneHead/ZoneHeadMomentAtdPage';
import ZoneHeadTCPage from './pages/zoneHead/ZoneHeadTCPage';
import ZoneHeadViewTrainerAtdPage from './pages/zoneHead/ZoneHeadViewTrainerAtdPage';
import ZoneHeadListPage from './pages/admin/ZoneHeadListPage';
import ZoneHeadCoordinatorListPage from './pages/zoneHead/ZoneHeadCoordinatorListPage';
import ZoneHeadApartmentListPage from './pages/zoneHead/ZoneHeadApartmentListPage';
import ZoneManagerCoordinatorListPage from './pages/zoneManager/ZoneManagerCoordinatorListPage';
import ZoneManagerAssignTrainerPage from './pages/zoneManager/ZoneManagerAssignTrainerPage';
import CoordinatorTrainerAssignPage from './features/coordinator/CoordinatorTrainerAssignPage';
import ZoneManagerApartmentListPage from './pages/zoneManager/ZoneManagerApartmentListPage';
import StudentOnlineCourseDetailPage from './pages/student/StudentOnlineCourseDetailPage';
import CoordinatorApartmentListPage from './pages/coordinator/CoordinatorApartmentListPage';
import AccountHistoryPage from './pages/apartment/AccountHistoryPage';
import AssignFacilityPage from './pages/apartment/AssignFacilityPage';
import MarketingMangerTCPage from './pages/marketingManager/MarketingMangerTCPage';
import TrainerMyCoursesPage from './pages/trainer/TrainerMyCoursesPage';
import MarektingMarClusterListPage from './pages/marketingManager/MarektingMarClusterListPage';
import ApartmentMomentAtdPage from './pages/apartment/ApartmentMomentAtdPage';
import AdminDiscountCouponCodePage from './pages/admin/AdminDiscountCouponCodePage';
import ZonalCoordinatorCouponCode from './pages/zonalcoordinator/ZonalCoordinatorCouponCode';
import ZonalCoordinatorAddApartmentPage from './pages/zonalcoordinator/ZonalCoordinatorAddApartmentPage';
import ZonalCoordinatorAddPTMPage from './pages/zonalcoordinator/ZonalCoordinatorAddPTMPage';
import ZonalCoordinatorTCPage from './pages/zonalcoordinator/ZonalCoordinatorTCPage';
import ParentCounsellorStudentEnquiryPage from './pages/parentcounsellor/ParentCounsellorStudentEnquiryPage';
import AdminReportPage from './pages/admin/AdminReportPage';
import ShareMemoryPage from './pages/parentcounsellor/ShareMemoryPage';
import ShareCoursePage from './pages/parentcounsellor/ShareCoursePage';
import RegisterStudentPage from './pages/trainer/RegisterStudentPage';
import AddEditApartmentListPage from './pages/admin/AddEditApartmentListPage';
import MarketingManagerAddZonalCoordinatorPage from './pages/marketingManager/MarketingManagerAddZonalCoordinatorPage';
import ZonalCoordinatorCheckAttendance from './features/zonalcoordinator/ZonalCoordinatorCheckAttendance';
import CluserHeadList from './features/admin/CluserHeadList';
import TemplatePage from './pages/admin/TemplatePage';
import AddCoursesPage from './pages/admin/AddCoursesPage';
import SchoolAddTeachersPage from './pages/school/SchoolAddTeachersPage';
import SchoolDashbaordPage from './pages/school/SchoolDashbaordPage';
import SchoolExploreCoursesPage from './pages/school/SchoolExploreCoursesPage';
import SchoolMyCoursesPage from './pages/school/SchoolMyCoursesPage';
import ProTeacherDashbaordPage from './pages/proteacher/ProTeacherDashbaordPage';
import ProTeacherExploreCoursesPage from './pages/proteacher/ProTeacherExploreCoursesPage';
import ProTeacherMyCoursesPage from './pages/proteacher/ProTeacherMyCoursesPage';
import ProTeacherSkillBoxPage from './pages/proteacher/ProTeacherSkillBoxPage';
import SchoolSkillBoxPage from './pages/school/SchoolSkillBoxPage';
import ProTeacherLsmDetailPage from './pages/proteacher/ProTeacherLsmDetailPage';
import LsmGrade from './features/addlms/LsmGrade';
import LmsCourseType from './features/addlms/LmsCourseType';
import LmsLanguage from './features/addlms/LmsLanguage';
import LmsBoard from './features/addlms/LmsBoard';
import LmsPublication from './features/addlms/LmsPublication';
import AddLmsPage from './pages/admin/AddLmsPage';
import CourseLmsListPage from './pages/admin/CourseLmsListPage';
import LmsFullContentDetailPage from './pages/admin/LmsFullContentDetailPage';
import TicketListPage from './pages/admin/TicketListPage';
import RaiseTicketForm from './features/commonfile/RaiseTicketForm';
import HrTrainerList from './features/hr/HrTrainerList';
import HrAcceptedTrainerList from './features/hr/HrAcceptedTrainerList';
import ChroHRList from './features/chro/ChroHRList';
import AssignedTicketList from './features/commonfile/AssignedTicketList';
import TrainerSalaryCalculate from './features/hr/TrainerSalaryCalculate';
import AddSyllabus from './features/admin/AddSyllabus';
import AddQuestionBank from './features/admin/AddQuestionBank';
import CommonRaisLeave from './features/commonfile/CommonRaisLeave';
import LeaveRequestList from './features/commonfile/LeaveRequestList';
import AssignZoneToMarketingExecutivePage from './pages/admin/AssignZoneToMarketingExecutivePage';
import MarketingManagerCouponCode from './pages/marketingManager/MarketingManagerCouponCode';
import CreatAssesments from './features/admin/CreatAssesments';
import LmsSubject from './features/addlms/LmsSubject';
import LmsTag from './features/addlms/LmsTag';
import LmsChapter from './features/addlms/LmsChapter';
import LmsTopic from './features/addlms/LmsTopic';
import AddEditSubtopic from './features/addlms/AddEditSubtopic';
import SchoolRequest from './features/admin/SchoolRequest';
import ZonalCoordinatorAssignZone from './features/zonalcoordinator/ZonalCoordinatorAssignZone';
import SubscriberList from './features/admin/SubscriberList';
import AddLmsQuestion from './pages/admin/AddLmsQuestion';
import ThreeJsLmsList from './features/addlms/ThreejsLmsList';
import FullContentDetailsThreejs from './features/addlms/FullContentDetailsThree';
import AddEditSubtopicThree from './features/addlms/AddEditSubtopicThree';
import ThreejsAddQuestion from './pages/admin/ThreejsAddQuestion';
import StudentSummerCampDetail from './features/student/StudentSummerCampDetail';
import ThreejsView from './features/addlms/ThreejsView';
import MyEvents from './features/student/MyEvents';
import BoardPage from './pages/admin/BoardPage';
import MediumPage from './pages/admin/MediumPage';
import GradePage from './pages/admin/GradePage';
import SectionPage from './pages/admin/SectionPage';
import Activelmsadd from './features/activelms/Activelmsadd';
import ActiveViewlms from './features/activelms/ActiveViewlms';
import ViewAllLmsContant from './pages/admin/ViewAllLmsContant';
import AddAiLms from './features/ailms/addailms';
import viewailms from './features/ailms/viewailms';
import DocName from './features/addlms/docName';
import OrderHistory from './pages/student/OrderHistory';




export const StudentRoutes = [
	{
		path: "/student/dashboard",
		Component: DashboardPage
	},
	{
		path: "/student/explore",
		Component: ExplorePage
	},
	{
		path: "/student/moments",
		Component: MomentsPage
	},
	{
		path: "/student/courses",
		Component: MyCoursesPage
	},
	{
		path: "/student/events",
		Component: MyEvents
	},
	{
		path: "/student/orderhistory",
		Component: OrderHistory
	},



	{
		path: "/student/piggybank",
		Component: PiggyBankPage
	},
	{
		path: "/student/notification",
		Component: NotificationPage
	},
	{
		path: "/student/coursedetail/:slug?/:apartments_id?/:course_id?",
		Component: StudentCourseDetailPage
	},
	{
		path: "/student/summercampcoursedetail/:slug?/:apartments_id?/:course_id?",
		Component: StudentSummerCampDetail
	},
	{
		path: "/student/onlinecoursedetail/:slug/:batch_id",
		Component: StudentOnlineCourseDetailPage
	},
	{
		path: "/student/raisedticket",
		Component: RaiseTicketForm
	},
]

export const TrainerRoutes = [
	{
		path: "/trainer/dashbaord",
		Component: TrainerDashbaordPage,
	},
	{
		path: "/trainer/schedules",
		Component: TrainerSchedulesPage,
	},
	{
		path: "/trainer/studentslist",
		Component: TrainerStudentsListPage,
	},
	{
		path: "/trainer/studentscourses",
		Component: TrainerStudentsCoursesPage,
	},
	{
		path: "/trainer/moments",
		Component: MomentsPage,
	},
	{
		path: "/trainer/payout",
		Component: TrainerPayoutPage,
	},
	{
		path: "/trainer/attendancelist",
		Component: TrainerAttendanceListPage,
	},
	{
		path: "/trainer/studentenquiry",
		Component: TrainerStudentEnquiryPage,
	},
	{
		path: "/trainer/mycourses",
		Component: TrainerMyCoursesPage,
	},
	{
		path: "/trainer/coursedetail/:slug?/:apartments_id?/:course_id?",
		Component: StudentCourseDetailPage
	},
	{
		path: "/trainer/summercampcoursedetail/:slug?/:apartments_id?/:course_id?",
		Component: StudentSummerCampDetail
	},
	{
		path: "/trainer/onlinecoursedetail/:slug/:batch_id",
		Component: StudentOnlineCourseDetailPage
	},
	{
		path: "/trainer/registerstudent",
		Component: RegisterStudentPage
	},
	{
		path: "/trainer/raisedticket",
		Component: RaiseTicketForm
	},
	{
		path: "/trainer/leaverequest",
		Component: CommonRaisLeave
	},
]

export const ApartmentRoutes = [
	{
		path: "/apartment/dashbaord",
		Component: ApartmentDashPage,
	},
	{
		path: "/apartment/termsandcondition",
		Component: ApartmentTCListPage,
	},
	{
		path: "/apartment/accounthistory",
		Component: AccountHistoryPage,
	},
	{
		path: "/apartment/assignfacility",
		Component: AssignFacilityPage,
	},
	{
		path: "/apartment/momentandattendance",
		Component: ApartmentMomentAtdPage,
	},








]

export const CoordinatorRoutes = [
	{
		path: "/coordinator/dashboard",
		Component: CoOrdinatorDashPage,
	},
	{
		path: "/coordinator/studentenquiry",
		Component: AddUserListPage,
	},
	{
		path: "/coordinator/termandcondition",
		Component: NewTCCoordinatorPage,
	},
	{
		path: "/coordinator/studentlist",
		Component: CoodiApartmentListPage,
	},
	{
		path: "/coordinator/momentandattendance",
		Component: CoordinatorMomentAttendancePage,
	},
	{
		path: "/coordinator/trainerattendance",
		Component: CoordinatorViewTraAtdPage,
	},
	{
		path: "/coordinator/trainerassign",
		Component: CoordinatorTrainerAssignPage,
	},
	{
		path: "/coordinator/apartmentlist",
		Component: CoordinatorApartmentListPage
	},
	{
		path: "/coordinator/raisedticket",
		Component: RaiseTicketForm
	},

]

export const AdminRoutes = [
	{
		path: "/admin/studentlist",
		Component: StudentListPage,
	},
	{
		path: "/admin/trainerlist",
		Component: TrainerListPage,
	},
	{
		path: "/admin/apartmentlist",
		Component: ApartmentListPage,
	},
	{
		path: "/admin/coordinatorlist",
		Component: CoOrdinatorListPage,
	},
	{
		path: "/admin/city",
		Component: CityPage,
	},
	{
		path: "/admin/state",
		Component: StatePage,
	},
	{
		path: "/admin/country",
		Component: CountryPage,
	},
	{
		path: "/admin/alluserlist",
		Component: AllUserListPage,
	},
	{
		path: "/admin/rolelist",
		Component: RoleListPage,
	},
	{
		path: "/admin/schoollist",
		Component: SchoolListPage,
	},
	{
		path: "/admin/courselist",
		Component: CourseListPage,
	},
	{
		path: "/admin/eventlist",
		Component: EventListPage,
	},
	{
		path: "/admin/orderlist",
		Component: OrderListPage,
	},
	{
		path: "/admin/facilitylist",
		Component: FacilityListPage,
	},
	{
		path: "/admin/termandcondition",
		Component: AdminTCListPage,
	},
	{
		path: "/admin/momentandattendance",
		Component: AdminMomentAttendancePage,
	},
	{
		path: "/admin/studentenquiry",
		Component: AdminStudentEnquiryPage,
	},
	{
		path: "/admin/trainerattendance",
		Component: AdminViewTrainerAtdPage,
	},
	{
		path: "/admin/assigntrainer",
		Component: AssignTranerPage,
	},
	{
		path: "/admin/clusterlist",
		Component: CluserHeadListPage,
	},
	{
		path: "/admin/zonelist",
		Component: AdminZoneListPage,
	},
	{
		path: "/admin/apartmentdetail/:id",
		Component: AparmentDetailPage,
	},
	{
		path: "/admin/zoneheadlist",
		Component: ZoneHeadListPage,
	},
	{
		path: "/admin/addcouponcode",
		Component: AdminDiscountCouponCodePage,
	},
	{
		path: "/admin/reports",
		Component: AdminReportPage,
	},
	{
		path: "/admin/addeditapartmentlist",
		Component: AddEditApartmentListPage,
	},
	{
		path: "/admin/addtemplate",
		Component: TemplatePage,
	},

	{
		path: "/admin/addcourses",
		Component: AddCoursesPage,
	},
	{
		path: "/admin/addlms/:lmsId?",
		Component: AddLmsPage,
	},
	{
		path: "/admin/addlmssubtopic/:topicId?/:subtopicId?",
		Component: AddEditSubtopic,
	},
	{
		path: "/admin/addsubtopicThreejs/:topicId?/:subtopicId?",
		Component: AddEditSubtopicThree,
	},

	{
		path: "/admin/addeditsubtopicthree/:topicId?/:subtopicId?",
		Component: AddEditSubtopicThree,
	},
	{
		path: "/admin/addlmsgrade",
		Component: LsmGrade,
	},
	{
		path: "/admin/addlmscoursetype",
		Component: LmsCourseType,
	},
	{
		path: "/admin/addlmslanguage",
		Component: LmsLanguage,
	},
	{
		path: "/admin/addlmsboard",
		Component: LmsBoard,
	},
	{
		path: "/admin/addlmspublication",
		Component: LmsPublication,
	},
	{
		path: "/admin/addlmssubject",
		Component: LmsSubject,
	},
	{
		path: "/admin/addlmstag",
		Component: LmsTag,

	},
	{
		path: "/admin/document",
		Component: DocName,

	},
	{
		path: "/admin/addlmschapter",
		Component: LmsChapter,

	},
	{
		path: "/admin/addlmstopic",
		Component: LmsTopic,

	},
	
	{
		path: "/admin/activitylms/add",
		Component: Activelmsadd,
	},
	{
		path: "/admin/activitylms/view",
		Component: ActiveViewlms,
	},

	{
		path: "/admin/ailms/add",
		Component: AddAiLms,
	},
	{
		path: "/admin/ailms/view",
		Component: viewailms,
	},

	{
		path: "/admin/activtitylms/view/:id",
		Component: ViewAllLmsContant,
	},

	{
		path: "/admin/lmslist",
		Component: CourseLmsListPage,
	},
	{
		path: "/admin/lmsfullcontent/:id",
		Component: LmsFullContentDetailPage,
	},
	{
		path: "/admin/ticketlist",
		Component: TicketListPage,
	},
	{
		path: "/admin/raisedticket",
		Component: RaiseTicketForm
	},
	{
		path: "/admin/addsyllabus",
		Component: AddSyllabus
	},

	{
		path: "/admin/addquestionbank",
		Component: AddQuestionBank
	},
	{
		path: "/admin/assignzonetomarketingexecutive",
		Component: AssignZoneToMarketingExecutivePage
	},
	{
		path: "/admin/createassesments",
		Component: CreatAssesments
	},

	{
		path: "/admin/schoolrequest",
		Component: SchoolRequest
	},

	{
		path: "/admin/subscriberlist",
		Component: SubscriberList,
	},
	{
		path: "/admin/addlms",
		Component: AddLmsQuestion
	},
	{
		path: "/admin/addquestionThreejs/:lmsId?",
		Component: ThreejsAddQuestion
	},
	{
		path: "/admin/threejslmslist",
		Component: ThreeJsLmsList
	},
	{
		path: "/admin/editthreejslmslist/:id",
		Component: FullContentDetailsThreejs
	},

	{
		path: "/admin/threejsview",
		Component: ThreejsView
	},
	{
		path: "/admin/board",
		Component: BoardPage
	},
	{
		path: "/admin/medium",
		Component: MediumPage
	},
	{
		path: "/admin/grade",
		Component: GradePage
	},
	{
		path: "/admin/section",
		Component: SectionPage
	},
	]

export const MarExecutiveRoutes = [
	{
		path: "/mareketingexcutive/apartmentlist",
		Component: ApartmentListMarExe,
	},
	{
		path: "/mareketingexcutive/facility",
		Component: FacilityListApartmentPage,
	},
	{
		path: "/mareketingexcutive/newtermandcondition",
		Component: NewTCExecutiveManager,
	},
	{
		path: "/mareketingexcutive/contactpersonlist",
		Component: ConstactPersonListPage,
	},

	{
		path: "/mareketingexcutive/raisedticket",
		Component: RaiseTicketForm
	},


]

export const MarManagerRoutes = [
	{
		path: "/mareketingmanager/addcouponcode",
		Component: MarketingManagerCouponCode,
	},
	{
		path: "/mareketingmanager/termsandcondition",
		Component: MarketingMangerTCPage,
	},
	{
		path: "/mareketingmanager/addexecutive",
		Component: AddMarketingExecutivePage,
	},


	{
		path: "/mareketingmanager/zonelist",
		Component: ZoneListPage,
	},
	{
		path: "/mareketingmanager/newtermandcondition",
		Component: NewTCManagerPage,
	},
	{
		path: "/mareketingmanager/onboardtermandcondition",
		Component: OnboardTCManagerPage,
	},

	{
		path: "/mareketingmanager/addcluster",
		Component: MarektingMarClusterListPage,
	},
	{
		path: "/mareketingmanager/addzonalcoordinator",
		Component: MarketingManagerAddZonalCoordinatorPage,
	},
	{
		path: "/mareketingmanager/raisedticket",
		Component: RaiseTicketForm
	},
]

export const ZoneManagerRoutes = [
	{
		path: "/zonemanager/termandcondition",
		Component: ZoneManagerTCListPage,
	},
	{
		path: "/zonemanager/enquiryform",
		Component: ZoneManagerEnquiryListPage,
	},
	{
		path: "/zonemanager/momentandattendance",
		Component: ZoneManagerMomentAttendancePage,
	},
	{
		path: "/zonemanager/trainerattendance",
		Component: ZoneManagerViewTraAtdPage,
	},
	{
		path: "/zonemanager/coordinatorlist",
		Component: ZoneManagerCoordinatorListPage,
	},
	{
		path: "/zonemanager/assigntrainer",
		Component: ZoneManagerAssignTrainerPage,
	},
	{
		path: "/zonemanager/apartmentlist",
		Component: ZoneManagerApartmentListPage,
	},
	{
		path: "/zonemanager/raisedticket",
		Component: RaiseTicketForm
	},


]


export const ZoneHeadRoutes = [
	{
		path: "/zonehead/enquiryform",
		Component: ZoneHeadEnquiryFormPage,
	},
	{
		path: "/zonehead/momentandattendance",
		Component: ZoneHeadMomentAtdPage,
	},
	{
		path: "/zonehead/studentlist",
		Component: ZoneHeadStudentListPage,
	},
	{
		path: "/zonehead/termsconditions",
		Component: ZoneHeadTCPage,
	},
	{
		path: "/zonehead/trainerattendance",
		Component: ZoneHeadViewTrainerAtdPage,
	},
	{
		path: "/zonehead/apartmentlist",
		Component: ZoneHeadApartmentListPage,
	},
	{
		path: "/zonehead/coordinatorlist",
		Component: ZoneHeadCoordinatorListPage,
	},
	{
		path: "/zonehead/raisedticket",
		Component: RaiseTicketForm
	},

]



export const ZonalCoordinatorRoutes = [
	{
		path: "/zonalcoordinator/addcouponcode",
		Component: ZonalCoordinatorCouponCode,
	},
	{
		path: "/zonalcoordinator/addapartment",
		Component: ZonalCoordinatorAddApartmentPage,
	},
	{
		path: "/zonalcoordinator/addptm",
		Component: ZonalCoordinatorAddPTMPage,
	},
	{
		path: "/zonalcoordinator/termsandcondition",
		Component: ZonalCoordinatorTCPage,
	},
	{
		path: "/zonalcoordinator/assigntrainer",
		Component: AssignTranerPage,
	},
	{
		path: "/zonalcoordinator/trainerattendance",
		Component: AdminViewTrainerAtdPage,
	},
	{
		path: "/zonalcoordinator/apartmentlist",
		Component: ApartmentListPage,
	},
	{
		path: "/zonalcoordinator/checkattendance",
		Component: ZonalCoordinatorCheckAttendance,
	},
	{
		path: "/zonalcoordinator/clusterlist",
		Component: CluserHeadList,
	},
	{
		path: "/zonalcoordinator/raisedticket",
		Component: RaiseTicketForm
	},
	{
		path: "/zonalcoordinator/assignzone",
		Component: ZonalCoordinatorAssignZone
	},




]

export const ParentCounsellorRoutes = [

	{
		path: "/parentcounsellor/studentenquiry",
		Component: ParentCounsellorStudentEnquiryPage,
	},

	{
		path: "/parentcounsellor/sharecourses",
		Component: ShareCoursePage
	},
	{
		path: "/parentcounsellor/sharememory",
		Component: ShareMemoryPage
	},
	{
		path: "/parentcounsellor/studentlist",
		Component: StudentListPage
	},
	{
		path: "/parentcounsellor/raisedticket",
		Component: RaiseTicketForm
	},
]


export const HRRoutes = [
	// {
	// 	path: "/humanresources/trainerresume",
	// 	Component: TrainerResumePage,
	// },
	{
		path: "/humanresources/resumebank",
		Component: HrTrainerList,
	},
	{
		path: "/humanresources/onboardedtrainers",
		Component: HrAcceptedTrainerList,
	},
	{
		path: "/humanresources/trainerattendance",
		Component: AdminViewTrainerAtdPage,
	},
	{
		path: "/humanresources/raisedticket",
		Component: RaiseTicketForm
	},
	{
		path: "/humanresources/trainersalarycalculate",
		Component: TrainerSalaryCalculate
	},
	{
		path: "/humanresources/leaverequestlist",
		Component: LeaveRequestList
	},



]


export const SchoolRoutes = [
	{
		path: "/school/dashbaord",
		Component: SchoolDashbaordPage,
	},
	{
		path: "/school/addteachers",
		Component: SchoolAddTeachersPage,
	},

	{
		path: "/school/explorecourses",
		Component: SchoolExploreCoursesPage,
	},
	{
		path: "/school/mycourses",
		Component: SchoolMyCoursesPage,
	},
	{
		path: "/school/skillbox",
		Component: SchoolSkillBoxPage,
	},
	{
		path: "/school/raisedticket",
		Component: RaiseTicketForm
	},
]


export const ProTeacherRoutes = [
	{
		path: "/proteacher/dashbaord",
		Component: ProTeacherDashbaordPage,
	},
	{
		path: "/proteacher/explorecourses",
		Component: ProTeacherExploreCoursesPage,
	},
	{
		path: "/proteacher/mycourses",
		Component: ProTeacherMyCoursesPage,
	},
	{
		path: "/proteacher/skillbox",
		Component: ProTeacherSkillBoxPage,
	},
	{
		path: "/proteacher/lmsdetail/:id",
		Component: ProTeacherLsmDetailPage,
	},
	{
		path: "/proteacher/raisedticket",
		Component: RaiseTicketForm
	},


]


export const COORoutes = [
	{
		path: "/coo/studentlist",
		Component: StudentListPage,
	},
	{
		path: "/coo/trainerlist",
		Component: TrainerListPage,
	},
	{
		path: "/coo/alluserlist",
		Component: AllUserListPage,
	},
	{
		path: "/coo/coordinatorlist",
		Component: CoOrdinatorListPage,
	},
	{
		path: "/coo/zoneheadlist",
		Component: ZoneHeadListPage,
	},
	{
		path: "/coo/orderlist",
		Component: OrderListPage,
	},
	{
		path: "/coo/courselist",
		Component: CourseListPage,
	},
	{
		path: "/coo/eventlist",
		Component: EventListPage,
	},
	{
		path: "/coo/apartmentlist",
		Component: ApartmentListPage,
	},
	{
		path: "/coo/reports",
		Component: AdminReportPage,
	},
	{
		path: "/coo/trainerattendance",
		Component: AdminViewTrainerAtdPage,
	},
	{
		path: "/coo/resumebank",
		Component: HrTrainerList,
	},
	{
		path: "/coo/onboardedtrainers",
		Component: HrAcceptedTrainerList,
	},
	{
		path: "/coo/assignticketList",
		Component: AssignedTicketList,
	},
	{
		path: "/coo/raisedticket",
		Component: RaiseTicketForm
	},
	{
		path: "/coo/apartmentdetail/:id",
		Component: AparmentDetailPage,
	},


]

export const CTORoutes = [
	{
		path: "/cto/studentlist",
		Component: StudentListPage,
	},
	{
		path: "/cto/trainerlist",
		Component: TrainerListPage,
	},
	{
		path: "/cto/alluserlist",
		Component: AllUserListPage,
	},
	{
		path: "/cto/coordinatorlist",
		Component: CoOrdinatorListPage,
	},
	{
		path: "/cto/zoneheadlist",
		Component: ZoneHeadListPage,
	},
	{
		path: "/cto/orderlist",
		Component: OrderListPage,
	},
	{
		path: "/cto/courselist",
		Component: CourseListPage,
	},
	{
		path: "/cto/eventlist",
		Component: EventListPage,
	},
	{
		path: "/cto/apartmentlist",
		Component: ApartmentListPage,
	},
	{
		path: "/cto/apartmentlist",
		Component: ApartmentListPage,
	},
	{
		path: "/cto/assignticketList",
		Component: AssignedTicketList,
	},
	{
		path: "/cto/raisedticket",
		Component: RaiseTicketForm
	},
	{
		path: "/cto/apartmentdetail/:id",
		Component: AparmentDetailPage,
	},



]


export const CEORoutes = [
	{
		path: "/ceo/studentlist",
		Component: StudentListPage,
	},
	{
		path: "/ceo/trainerlist",
		Component: TrainerListPage,
	},
	{
		path: "/ceo/alluserlist",
		Component: AllUserListPage,
	},
	{
		path: "/ceo/coordinatorlist",
		Component: CoOrdinatorListPage,
	},
	{
		path: "/ceo/zoneheadlist",
		Component: ZoneHeadListPage,
	},
	{
		path: "/ceo/orderlist",
		Component: OrderListPage,
	},
	{
		path: "/ceo/courselist",
		Component: CourseListPage,
	},
	{
		path: "/ceo/eventlist",
		Component: EventListPage,
	},
	{
		path: "/ceo/apartmentlist",
		Component: ApartmentListPage,
	},
	{
		path: "/ceo/reports",
		Component: AdminReportPage,
	},
	{
		path: "/ceo/assignticketList",
		Component: AssignedTicketList,
	},
	{
		path: "/ceo/raisedticket",
		Component: RaiseTicketForm
	},
	{
		path: "/ceo/apartmentdetail/:id",
		Component: AparmentDetailPage,
	},

]


export const CAORoutes = [
	{
		path: "/cao/studentlist",
		Component: StudentListPage,
	},
	{
		path: "/cao/trainerlist",
		Component: TrainerListPage,
	},
	{
		path: "/cao/orderlist",
		Component: OrderListPage,
	},
	{
		path: "/cao/courselist",
		Component: CourseListPage,
	},
	{
		path: "/cao/eventlist",
		Component: EventListPage,
	},
	{
		path: "/cao/apartmentlist",
		Component: ApartmentListPage,
	},
	{
		path: "/cao/trainerattendance",
		Component: AdminViewTrainerAtdPage,
	},
	{
		path: "/cao/raisedticket",
		Component: RaiseTicketForm
	},
	{
		path: "/cao/apartmentdetail/:id",
		Component: AparmentDetailPage,
	},


]


export const CFORoutes = [
	{
		path: "/cfo/studentlist",
		Component: StudentListPage,
	},

	{
		path: "/cfo/alluserlist",
		Component: AllUserListPage,
	},
	{
		path: "/cfo/coordinatorlist",
		Component: CoOrdinatorListPage,
	},
	{
		path: "/cfo/zoneheadlist",
		Component: ZoneHeadListPage,
	},
	{
		path: "/cfo/orderlist",
		Component: OrderListPage,
	},
	{
		path: "/cfo/courselist",
		Component: CourseListPage,
	},
	{
		path: "/cfo/eventlist",
		Component: EventListPage,
	},
	{
		path: "/cfo/apartmentlist",
		Component: ApartmentListPage,
	},
	{
		path: "/cfo/reports",
		Component: AdminReportPage,
	},
	{
		path: "/cfo/raisedticket",
		Component: RaiseTicketForm
	},
	{
		path: "/cfo/apartmentdetail/:id",
		Component: AparmentDetailPage,
	},



]

export const CMORoutes = [
	{
		path: "/cmo/orderlist",
		Component: OrderListPage,
	},
	{
		path: "/cmo/courselist",
		Component: CourseListPage,
	},
	{
		path: "/cmo/eventlist",
		Component: EventListPage,
	},
	{
		path: "/cmo/apartmentlist",
		Component: ApartmentListPage,
	},
	{
		path: "/cmo/reports",
		Component: AdminReportPage,
	},
	{
		path: "cmo/raisedticket",
		Component: RaiseTicketForm
	},
	{
		path: "/cmo/apartmentdetail/:id",
		Component: AparmentDetailPage,
	},



]


export const SMERoutes = [
	{
		path: "/sme/studentlist",
		Component: StudentListPage,
	},
	{
		path: "/sme/trainerlist",
		Component: TrainerListPage,
	},
	{
		path: "/sme/courselist",
		Component: CourseListPage,
	},
	{
		path: "/sme/eventlist",
		Component: EventListPage,
	},
	{
		path: "/sme/raisedticket",
		Component: RaiseTicketForm
	}
]

export const LAMRoutes = [
	{
		path: "/lam/studentlist",
		Component: StudentListPage,
	},
	{
		path: "/lam/trainerlist",
		Component: TrainerListPage,
	},
	{
		path: "/lam/orderlist",
		Component: OrderListPage,
	},
	{
		path: "/lam/courselist",
		Component: CourseListPage,
	},
	{
		path: "/lam/eventlist",
		Component: EventListPage,
	},
	{
		path: "/lam/apartmentlist",
		Component: ApartmentListPage,
	},
	{
		path: "/lam/trainerattendance",
		Component: AdminViewTrainerAtdPage,
	},
	{
		path: "/lam/assignticketList",
		Component: AssignedTicketList,
	},
	{
		path: "/lam/raisedticket",
		Component: RaiseTicketForm
	},
	{
		path: "/lam/apartmentdetail/:id",
		Component: AparmentDetailPage,
	},

]



export const CHRORoutes = [

	{
		path: "/chro/trainerattendance",
		Component: AdminViewTrainerAtdPage,
	},
	{
		path: "/chro/resumebank",
		Component: HrTrainerList,
	},
	{
		path: "/chro/onboardedtrainers",
		Component: HrAcceptedTrainerList,
	},
	{
		path: "/chro/hrlist",
		Component: ChroHRList,
	},
	{
		path: "/chro/raisedticket",
		Component: RaiseTicketForm
	},




]



